import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import SearchButton from '../../components/atoms/SearchButton';
import StepBackButton from '../../components/atoms/StepBackButton';
import IdentityUserKidTable from '../organisms/IdentityUserKidTable';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import {
  getIdentityUserKids,
  GET_IDENTITY_USER_KIDS_SUCCESS
} from '../../actions/Identity';
import { getAccounts } from '../../actions/Accounts';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textField150: {
    padding: '0px 5px 0px 5px',
    width: '200px'
  },
  button: {
    margin: '5px 5px'
  },
  buttonLeft: {
    textAlign: 'left'
    // CSV出力ボタンを実装時にコメントアウトを外す
    // float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  checkboxSearch: {
    width: 400,
    padding: '0px 5px 0px 5px',
    marginTop: 16,
    marginBottom: 8,
    marginRight: 0
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const poorStatusArr = [
  { label: '', name: '選択なし' }, // status post new regis
  { label: 'REVIEW', name: '審査中' }, // status post new regis
  { label: 'OK', name: '審査OK' }, // status approved, not editable
  { label: 'NG', name: '審査NG' }, // status admin refused
  { label: 'RESUBMIT', name: '再提出依頼中' } // status admin resubmit
];

const userKidStatusArr = [
  { label: '', name: '選択なし' }, // status post new regis
  { label: 'REVIEW', name: '審査中' }, // status post new regis
  { label: 'OK', name: '審査OK' }, // status approved, not editable
  { label: 'NG', name: '審査NG' }, // status admin refused
  { label: 'RESUBMIT', name: '再提出依頼中' } // status admin resubmit
];

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      statuses: state.identities.statuses
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getIdentityUserKids, getAccounts },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openModal', 'updateOpenModal', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('selected', 'setSelected', []),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('operatorName', 'setOperatorName', 0),
  withState('gochiType', 'setGochiType', 0),
  withState('userId', 'setUserId', ''),
  withState('displayName', 'setdisplayName', ''),
  withState('poorStatus', 'setPoorStatus', ''),
  withState('userKidStatus', 'setUserKidStatus', ''),
  withState('email', 'setEmail', ''),
  withState('createdFrom', 'setCreatedFrom', null),
  withState('createdTo', 'setCreatedTo', null),
  withState('birthdayMonth4Check', 'setBirthdayMonth4Check', 0),
  withState('resultMessage', 'setResultMessage', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }

      const searchKey = {
        displayName: props.displayName,
        userId: props.userId,
        poorStatus: props.poorStatus,
        userKidStatus: props.userKidStatus,
        email: props.email,
        createdFrom: props.createdFrom,
        createdTo: props.createdTo,
        birthdayMonth4Check: props.birthdayMonth4Check,
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);

      props.actions
        .getIdentityUserKids(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          if (data.type === GET_IDENTITY_USER_KIDS_SUCCESS) {
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            props.updateOpenTable(true);
          } else {
            props.setResultMessage('エラーが発生しました！');
            props.updateOpenProgress(true);
            props.updateLoading(false);
          }
        })
        .catch(() => {
          props.setResultMessage('');
          props.updateOpenProgress(false);
          props.updateLoading(false);
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        this.props.actions
          .getIdentityUserKids({
            page: this.props.page,
            limit: this.props.rowsPerPage
          })
          .then(identityData => this.props.checkSession(identityData));
        this.props.updateOpenTable(true);
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    handleRedirect,
    handleChangePage,
    account,
    openDrawer,
    updateOpenDrawer,
    openTable,
    updateOpenTable,
    loading,
    openProgress,
    displayName,
    setdisplayName,
    userId,
    setUserId,
    page,
    poorStatus,
    setPoorStatus,
    userKidStatus,
    setUserKidStatus,
    email,
    setEmail,
    createdFrom,
    setCreatedFrom,
    createdTo,
    setCreatedTo,
    birthdayMonth4Check,
    setBirthdayMonth4Check,
    resultMessage,
    updateOpenProgress,
    updateLoading,
    checkSession,
    setResultMessage
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;
    const roles = {
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 100;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchKey = {
      displayName,
      userId,
      poorStatus,
      userKidStatus,
      email,
      createdFrom,
      createdTo,
      birthdayMonth4Check,
      page,
      limit: limitNum
    };
    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, limitNum);
    };
    const backAction = () => handleRedirect('/release_step');
    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            こどもごちめし対象者管理
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            <div>
              {(roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="メールアドレス"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={email}
                  onChange={e => {
                    setEmail(e.target.value);
                  }}
                />
              )}
              {(roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="こども申請日(From)"
                  type="date"
                  placeholder="部分一致"
                  className={classes.textField}
                  margin="normal"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={createdFrom}
                  onChange={e => {
                    setCreatedFrom(e.target.value);
                  }}
                  onBlur={e => {
                    if (!createdFrom) {
                      e.target.value = '';
                      setCreatedFrom('');
                    }
                  }}
                />
              )}
              {(roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="こども申請日(To)"
                  type="date"
                  placeholder="部分一致"
                  className={classes.textField}
                  margin="normal"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={createdTo}
                  onChange={e => {
                    setCreatedTo(e.target.value);
                  }}
                  onBlur={e => {
                    if (!createdTo) {
                      e.target.value = '';
                      setCreatedTo('');
                    }
                  }}
                />
              )}
            </div>
            <div>
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="ユーザ名"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={displayName}
                  onChange={e => {
                    setdisplayName(e.target.value);
                  }}
                />
              )}
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="ユーザID"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={userId}
                  onChange={e => {
                    setUserId(e.target.value);
                  }}
                />
              )}
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  select
                  label="困窮者審査状況"
                  className={classes.textField}
                  margin="normal"
                  value={poorStatus}
                  onChange={e => {
                    setPoorStatus(e.target.value);
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                >
                  {poorStatusArr.map(item => {
                    return (
                      <MenuItem key={item.label} value={item.label}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
              )}
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  select
                  label="生年月日審査状況"
                  className={classes.textField}
                  margin="normal"
                  value={userKidStatus}
                  onChange={e => {
                    console.log('e.target.value', e.target.value);
                    setUserKidStatus(e.target.value);
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                >
                  {userKidStatusArr.map(item => {
                    return (
                      <MenuItem key={item.label} value={item.label}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
              )}
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <FormControlLabel
                  value="true"
                  className={classes.checkboxSearch}
                  margin="normal"
                  control={
                    <Checkbox
                      color="primary"
                      checked={birthdayMonth4Check === 1}
                      onChange={e => {
                        setBirthdayMonth4Check(e.target.checked ? 1 : 0);
                      }}
                    />
                  }
                  label="4月生まれこどもを含むユーザのみ"
                />
              )}
            </div>
            {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
              <div className={classes.buttonLeft}>
                <SearchButton onClickAction={searchAction} />
              </div>
            )}
            <div style={{ marginTop: 5 }}>
              ※OCR読み取りジョブの仕様
              <br />
              {
                '・1時間（00分の時点）に1回実行して、毎回、登録日時がジョブ実行時点の5分前まで（created_at < ジョブ実行時点 - 5分）で、かつOCR読み取りしていないこども情報の最大100件を処理する'
              }
              <br />
              ・処理速度：~10秒 / 件
              <br />
              <br />
              ※自動承認ジョブの仕様
              <br />
              ・1時間（30分の時点）に1回実行して、毎回、最大100親ユーザー分のOCR読み取りしたこども情報を処理する
              <br />
              ・処理速度：~100件 / 分
              <br />
              <br />
              ※管理者による困窮者審査は、ジョブと競合しないように、少なくとも2時間以前のデータを審査する必要がある
              <br />
              ※管理者とジョブが同時に同一データを更新した場合は、管理者の審査結果が優先され、以後そのデータについてジョブは承認を行わない
            </div>
          </div>
          {openTable && (
            <IdentityUserKidTable
              searchKey={searchKey}
              roles={roles}
              page={page}
              handleChangePage={handleChangePage}
              selectedPage={page}
              poorStatusArr={poorStatusArr}
              userKidStatusArr={userKidStatusArr}
              updateOpenProgress={updateOpenProgress}
              updateLoading={updateLoading}
              checkSession={checkSession}
              setResultMessage={setResultMessage}
            />
          )}
          {isShop && !isReleased && (
            <div>
              <StepBackButton onClickAction={backAction} />
            </div>
          )}
        </Paper>
        <ProgressDialog
          openProgress={openProgress}
          loading={loading}
          resultMessage={resultMessage}
          progressOkAction={() => updateOpenProgress(false)}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
